import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
//import $ from 'jquery';
import '../css/MainContent.css';
import '../css/novel.css';

const LATEST_REVALIDATE_INTERVAL_MS = 30 * 1000;
const SITE_NAME = "水瓜書房";

function extractArticleTitle(html) {
  const doc = new DOMParser().parseFromString(String(html || ""), "text/html");
  const candidate = doc.querySelector(".title h1") || doc.querySelector("article h1") || doc.querySelector("h1");
  return candidate?.textContent?.trim() || "";
}

function MainContent({ slug }) {
  const params = useParams();
  const finalSlug = slug || params.slug || "latest";

  const file = `/content/${finalSlug}.html`;
  const legacyFile = `/archive/${finalSlug}.html`;
  const isLatest = finalSlug === "latest";

  const [html, setHtml] = useState("");

  useEffect(() => {
    let active = true;
    let inFlight = false;
    let lastFetchedAt = 0;

    const ensureFragment = (text, label) => {
      const normalized = String(text || "").trim().toLowerCase();
      if (normalized.startsWith("<!doctype html") || normalized.includes("<html")) {
        throw new Error(`${label} returned app shell instead of article fragment`);
      }
      return text;
    };

    const fetchContent = async () => {
      if (inFlight) return;
      inFlight = true;
      try {
        const res = await fetch(file);
        if (!res.ok) throw new Error(`content fetch failed: ${res.status}`);
        const text = ensureFragment(await res.text(), "content");
        if (active) {
          setHtml(text);
          lastFetchedAt = Date.now();
        }
      } catch (_) {
        try {
          const fallback = await fetch(legacyFile);
          if (!fallback.ok) {
            throw new Error(`legacy fetch failed: ${fallback.status}`);
          }
          const text = ensureFragment(await fallback.text(), "legacy");
          if (active) {
            setHtml(text);
            lastFetchedAt = Date.now();
          }
        } catch (err) {
          if (active) {
            setHtml(`<p>記事を読み込めませんでした: ${String(err)}</p>`);
            lastFetchedAt = Date.now();
          }
        }
      } finally {
        inFlight = false;
      }
    };

    const maybeRevalidateLatest = () => {
      if (!isLatest) return;
      if (document.visibilityState && document.visibilityState !== "visible") return;
      const now = Date.now();
      if (now - lastFetchedAt < LATEST_REVALIDATE_INTERVAL_MS) return;
      fetchContent();
    };

    fetchContent();

    if (isLatest) {
      window.addEventListener("focus", maybeRevalidateLatest);
      document.addEventListener("visibilitychange", maybeRevalidateLatest);
    }

    return () => {
      active = false;
      if (isLatest) {
        window.removeEventListener("focus", maybeRevalidateLatest);
        document.removeEventListener("visibilitychange", maybeRevalidateLatest);
      }
    };
  }, [file, legacyFile, isLatest]);

  useEffect(() => {
    if (isLatest) {
      document.title = SITE_NAME;
      return;
    }

    const articleTitle = extractArticleTitle(html);
    document.title = articleTitle ? `${articleTitle} | ${SITE_NAME}` : SITE_NAME;
  }, [html, isLatest]);

  return (
    <div
      id="home-content"
      className="content"
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}

export default MainContent;
